<template>
  <div class="row">
    <div v-if="isProvider" class="col-12">
      <h1>Profile</h1>
      <p>If you wish to hear a cash register sound upon receiving an opportunity, be sure to check Allow Audio.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-1"></div>
    <div class="col-2">
      <div class="form-check custom-checkbox-wrapper">
        <input type="checkbox" id="allow-audio" :checked="allowAudio" class="form-check-input custom-checkbox-medium" @change="toggleAudio" />
        <label class="form-check-label ms-2" for="flexCheckDefault"> Allow Audio </label>
        <button class="btn btn-primary btn-sm ms-2" @click="play">Play</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { audioStore } from '@/stores/audio'
export default {
  name: 'ProfileView',
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(audioStore, ['allowAudio']),
    isProvider() {
      let _is = false
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(audioStore, ['toggleAllowAudio', 'playSound']),
    async toggleAudio(event) {
      const isChecked = event.target.checked
      this.toggleAllowAudio(isChecked)
    },
    play() {
      this.playSound()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-checkbox-wrapper {
  border: 1px solid #ccc;
  padding: 10px;
  padding-left: 40px;
  padding-bottom: 15px;
}
</style>
